import TeamManagementDashboard from "./TeamManagementDashboard/TeamManagementDashboard";

const TeamManagement = () => {
  return (
    <>
      <TeamManagementDashboard />
    </>
  );
};
export default TeamManagement;
